module.exports = __webpack_public_path__ + "img/fly.46de9128.svg";